export const classes = {
  wrapper: 'text-sm text-slate-500',
};
